var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-loader"},[_c('div',{staticClass:"common-loader__container"},[_c('ui-loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }